import Vue from "vue";
import App from "./app.vue";
// Vue.use(iView);
import { router } from "./router/";
import "famfamfam-flags/dist/sprite/famfamfam-flags.css";
//import './theme.less'
import Ajax from "./lib/ajax";
import Util from "./lib/util";
import SignalRAspNetCoreHelper from "./lib/SignalRAspNetCoreHelper.asdcom";
import store from "src/store/index";
import { appRouters, otherRouters } from "./router/router";
Vue.config.productionTip = false;
if (!abp.utils.getCookieValue("Abp.Localization.CultureName")) {
	let language = navigator.language;
	abp.utils.setCookieValue("Abp.Localization.CultureName", language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}

import Validation from "@/asdcom/Validation";
import appconst from "./lib/appconst";
import {L} from "./lib/asdcombase";
import "./main.asdcom.ts";
import { Asdcom } from "./asdcom/appservice.asdcom";

// import 'vuetify/dist/vuetify.min.css';
// import Vuetify from '@/plugins/asdcom/vuetify';
// Vue.use(Vuetify);
// import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify';

import 'vuetify/dist/vuetify.min.css';
import util from "./lib/util";
Vue.use(Vuetify);


// Vue.prototype.$eventBus = new Vue();
export const bus = new Vue();

Ajax.get("/AbpUserConfiguration/GetAll").then((data: any) => {
	Util.abp = Util.extend(true, Util.abp, data.data.result);
	//abp.log.debug(`abp.session.userId is set by [/AbpUserConfiguration/GetAll] : ${abp.session.userId}`);
	if (data && data.data && data.data.result && data.data.result.localization && data.data.result.localization.values) {
		Validation.init(data.data.result.localization.values[appconst.localization.defaultLocalizationSourceName]);
	}
	new Vue({
		vuetify: new Vuetify({
		  icons: {
		    iconfont: 'mdi',
		  },
		  theme: {
			themes: {
			  light: {
				primary: "#00a5ff",
				error: "#d81e2a",
				success: "#67ae00",
				warning: "#f1740d"
			  }
			}
		  },	
		}),
		render: h => h(App),
		router: router,
		store: store,
		data: {
			currentPageName: "",
			activityTimer: undefined,
			lastActivityTime: new Date(),
			activityTimeoutMillSec: appconst.defaultInactivityTimeoutMinutes * 60000,
		},
		async mounted() {
			// IE warning.
			if (navigator.appName == 'Microsoft Internet Explorer' ||
				!!(navigator.userAgent.match(/Trident/g) ||
					navigator.userAgent.match(/rv11|rv:11/g)) ||
				navigator.userAgent.match(/MSIE/g)) {
				sweetAlert({
					title: L("IEWarning"),
					text: L("IEWarningText"),
					icon: "warning",
				})
			}

			/// initialize new session.
			// await this.$store.dispatch({
			// 	type: "asdcom/session/init",
			// });
			const sessionService = new Asdcom.SessionAppService();
			await sessionService.initialize();
			
			// if (!!this.$store.state.session.user && this.$store.state.session.application.features["SignalR"]) {
			// 	if (this.$store.state.session.application.features["SignalR.AspNetCore"]) {
			// 		SignalRAspNetCoreHelper.initSignalR();
			// 	}
			// }


			// if (!!this.$store.state.session.user) {
			// 	SignalRAspNetCoreHelper.initSignalR(()=>{
			// 		this.$appsvs.staffSignalrService.init();
			// 	});
			// }

			if (this.$store.state.session.user != undefined) {
				// this.startInactivityTimer(this.logoutUser);
				this.startInactivityTimer();
			}
			// this.currentPageName = this.$route.name as string;
			// this.$store.commit('app/initCachepage');
			// this.$store.commit('app/updateMenulist');
		},
		methods: {
			startInactivityTimer() {
			// abp.log.debug("startInactivityTimer called ...");
			// calc inactivity timeout milliseconds.
			let mnts: any = asdcom.config.activityTimeoutMin || appconst.defaultInactivityTimeoutMinutes;
			if(util.abp.auth.hasPermission("Pages.Tenant.StaffUser")){
				mnts = asdcom.config.activityTimeoutMinAdvocate || appconst.defaultInactivityTimeoutMinAdvocate;
			}
			this.activityTimeoutMillSec = mnts * 60000;
			// abp.log.debug({ "timer minutes": mnts, "timer millisec": this.activityTimeoutMillSec });
	
	
			this.resetTimer();
	
			// reset timer on DOM Events
			document.onload = this.setLastActivityTime;
			//document.onmousemove = this.setActivityTime;
			document.onmousedown = this.setLastActivityTime; // touchscreen presses
			document.ontouchstart = this.setLastActivityTime;
			document.onclick = this.setLastActivityTime; // touchpad clicks
			document.onscroll = this.setLastActivityTime; // scrolling with arrow keys
			document.onkeypress = this.setLastActivityTime;
		},
	
		setLastActivityTime(e: any) {
			this.lastActivityTime = new Date();
			// abp.log.debug({"setLastActivityTime":this.lastActivityTime.getTime(), "event":e});
		},
	
		resetTimer() {
			// abp.log.debug("resetTimer called ...");
			clearTimeout(this.activityTimer);
	
			// calc activity.
			if (this.isUserActive()) {
				this.isSessionValid().then((res: boolean) => {
					if (res) {
						// this.timer = setTimeout(this.logoutUser, this.activityTimeoutMillSec) as any;
						this.activityTimer = setTimeout(this.resetTimer, 60000) as any;
					}
				});
			}
			else{
				this.logoutUser();
			}
		},
	
		logoutUser() {
			this.$appsvs.tokenAuth.logOut().then(() => {
				// abp.log.debug("main.logoutUser called...");
	
				if (util.abp.auth.hasPermission("Pages.Tenant.StaffUser")) {
					//sweetAlert({text:"You have been logged out due to inactivity.", icon:"info"});
					//this.$router.push('/');
					location.reload();
				} else {
					window.location.replace("https://www.google.com");
				}
			});
		},
	
		isUserActive():boolean{
			const lastActivityDiffMillSec = new Date().getTime() - this.lastActivityTime.getTime();
			// abp.log.debug({"lastActivityDiffMillSec":lastActivityDiffMillSec, "timeOutMillSec":this.activityTimeoutMillSec});
			// abp.log.debug({"isUserActive":this.activityTimeoutMillSec > lastActivityDiffMillSec});
			return this.activityTimeoutMillSec > lastActivityDiffMillSec;
		},
	
		async isSessionValid(callCounter: number = 0): Promise<boolean> {
			// abp.log.debug("isSessionValid called..... counter = " + callCounter);
			const tokenExp = localStorage.getItem(appconst.authorization.tokenExpName);
			// abp.log.debug({ "tokenExp": tokenExp });
			if (tokenExp == null) {
				// abp.log.debug("isSessionValid return false");
				return false;
			} else {
				const timeBufferMillSec = 1000 *60
				const tokenTimeupMillSec = (new Date(tokenExp).getTime() - new Date().getTime()) - timeBufferMillSec;
				// console.warn( "this.activityTimeoutMillSec",this.activityTimeoutMillSec, "tokenTimeupMillSec", tokenTimeupMillSec);
				if (this.activityTimeoutMillSec < tokenTimeupMillSec) {
					// abp.log.debug("isSessionValid return true");
					return true;
				} else {
					//refresh token.
					// abp.log.debug("isSessionValid before refresh token");
					return this.$appsvs.tokenAuth.refreshAuthToken().then(res => {
						// abp.log.debug("refreshAuthToken returned.");
						if (callCounter < 3) {
							const cntr = callCounter + 1;
							return this.isSessionValid(cntr);
						}
						// abp.log.debug("isSessionValid return true2");
						return true;
					});
				}
			}
		}	
	},
	watch: {
		"$store.session.user": function (val: any, oldVal: any) {
			//abp.log.debug({ "session user watch:": [val, oldVal] });
			if (val != undefined) {
				this.startInactivityTimer(); //this.logoutUser);
			}
		},
	},
		// created() {
		// 	let tagsList: Array<any> = [];
		// 	appRouters.map((item) => {
		// 	    if (item.children.length <= 1) {
		// 	        tagsList.push(item.children[0]);
		// 	    } else {
		// 	        tagsList.push(...item.children);
		// 	    }
		// 	});
		// 	this.$store.commit('app/setTagsList', tagsList);
		// },
	}).$mount("#app");
});